import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_ALL_CLOUD_DRIVE_GROUPS,
  SET_CLOUD_SOURCE_FIELDS_DATA,
} from "../../../redux/constants/constants";
import {
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import InfoIcon from "../../../assets/icons/InfoIcon.svg";
import MSADButtons from "./MSADButtons";

function MicrosoftADDataSourceForm({
  isEditMode,
  error,
  removeErrorByKey,
  dataSourceData,
  saveDataSourceFieldData,
  staticInstructionsOpen,
  handleSaveActions,
  toggleDrawer
}) {
  const dispatch = useDispatch();
  const cloudSourceData = useSelector(
    (state) => state.CreateSourceReducer.cloudSourceData
  );
  const {
    domainName,
  } = cloudSourceData;
  const [MSADConfigurationCheck, setMSADConfigurationCheck] = useState(false);

  useEffect(() => {
    if (dataSourceData && !isEmpty(dataSourceData.secret1)) {
      dispatch({
        type: GET_ALL_CLOUD_DRIVE_GROUPS,
        payload: dataSourceData.id,
      });
    }
  }, [dataSourceData]);

  const handleConfirmConfiguration = (event) =>
    setMSADConfigurationCheck(event.target.checked);

   const handleMSADConfig = () => {
    saveDataSourceFieldData();
    staticInstructionsOpen(true);
  };

    const renderMSADConsent = () => (
      <div
        className={
          MSADConfigurationCheck
            ? "logConfigurationDoneContainer logSourceConfigDone"
            : "logConfigurationDoneContainer"
        }
      >
        <FormControlLabel
          className="confirmContainer msad"
          control={
            <Checkbox
              color="primary"
              checked={MSADConfigurationCheck}
              onChange={handleConfirmConfiguration}
            />
          }
          label="Please accept if MSAD configuration is done"
          labelPlacement="end"
        />
        <div className="WinlogbeatContainer">
          <img src={InfoIcon} alt="info icon" />
          <div className="winlogbeatText" onClick={handleMSADConfig}>
            Link To MSAD configuration
          </div>
        </div>
      </div>
    );


  return (
    <div>
      <div className="MSADFieldContainer">
        <div>Domain Name{<span className="MSAD-required-field">*</span>}</div>
        <TextField
          required
          value={domainName}
          onChange={(event) => {
            dispatch({
              type: SET_CLOUD_SOURCE_FIELDS_DATA,
              payload: { ...cloudSourceData, domainName: event.target.value },
            });
            removeErrorByKey("domainName");
          }}
          id="outlined-required"
          variant="outlined"
          fullWidth={true}
          placeholder="Domain Name"
          disabled={isEditMode}
        />
        {error && error.domainName ? (
          <div className="MSAD-required-field">{error.domainName}</div>
        ) : null}
      </div>
      {!isEditMode && renderMSADConsent()}
      <MSADButtons
        toggleDrawer={toggleDrawer}
        handleSaveActions={handleSaveActions}
        isEditMode={isEditMode}
        MSADConfigurationCheck={MSADConfigurationCheck}
      />
    </div>
  );
}

export default MicrosoftADDataSourceForm;